import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ApiUrlService } from '../../core/api-url.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-me-page',
  standalone: true,
  imports: [FormsModule, NgIf],
  templateUrl: './me.page.html',
  styleUrl: './me.page.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MePageComponent implements OnInit {
  prenom = '';
  nom = '';
  email = '';
  plateau = '';
  tassesParJour = 0;
  joursPresentielParSemaine = 0;
  message = '';
  errorMessage = '';
  isLoading = false;

  constructor(
    private readonly http: HttpClient,
    private readonly apiUrl: ApiUrlService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.http.get<MeResponse>(this.apiUrl.build('/api/me')).subscribe({
      next: response => {
        this.prenom = response.prenom;
        this.nom = response.nom;
        this.email = response.email;
        this.plateau = response.plateau.code;
        this.tassesParJour = response.profil.tassesParJour;
        this.joursPresentielParSemaine = response.profil.joursPresentielParSemaine;
        this.cdr.markForCheck();
      },
      error: () => {
        this.errorMessage = 'Impossible de charger vos informations.';
        this.cdr.markForCheck();
      }
    });
  }

  save(): void {
    this.isLoading = true;
    this.message = '';
    this.errorMessage = '';
    this.http
      .put<UserProfileResponse>(this.apiUrl.build('/api/me/profile'), {
        tassesParJour: this.tassesParJour,
        joursPresentielParSemaine: this.joursPresentielParSemaine
      })
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.cdr.markForCheck();
        })
      )
      .subscribe({
        next: response => {
          this.tassesParJour = response.tassesParJour;
          this.joursPresentielParSemaine = response.joursPresentielParSemaine;
          this.message = 'Profil enregistré.';
          this.cdr.markForCheck();
        },
        error: () => {
          this.errorMessage = 'Erreur lors de la sauvegarde.';
          this.cdr.markForCheck();
        }
      });
  }

  get tassesParSemaine(): number {
    return this.tassesParJour * this.joursPresentielParSemaine;
  }
}

interface MeResponse {
  prenom: string;
  nom: string;
  email: string;
  plateau: {
    code: string;
  };
  profil: UserProfileResponse;
}

interface UserProfileResponse {
  tassesParJour: number;
  joursPresentielParSemaine: number;
}
